import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import useAppInfo from '../../../../hooks/appInfo.hook';
import { storeStatus } from '../../../../utils/constants';

const messages = {
    trial: {
        title: 'Você está no período de teste',
        text: 'As notificações serão enviadas apenas para os celulares pareados por meio do Visualizador Mobilizei. ' +
            'Após a publicação do seu aplicativo, todos os clientes que instalarem o app poderão receber suas notificações.'
    },
    unpublished: {
        title: 'Seu aplicativo ainda não está publicado',
        text: 'Por enquanto, as notificações chegam apenas aos celulares pareados por meio do Visualizador Mobilizei. ' +
            'Quando seu aplicativo for publicado, todos os clientes que instalarem o app poderão receber suas notificações.'
    }
};

// Same shape as the WarningCard, but neutral: an app not yet published is not a
// problem, it only changes who receives the notification. The text depends on
// whether the store is still on trial or already active, waiting for the publish.
export default function UnpublishedAppCard() {
    const { appInfo } = useAppInfo();

    const { title, text } = appInfo.storeStatus === storeStatus.ON_TRIAL
        ? messages.trial
        : messages.unpublished;

    return (
        <Card elevation={1} sx={{ background: '#f5f5f5', borderRadius: '4px', mt: 2 }}>
            <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 4, px: 3, py: 2, '&:last-child': { pb: 2 } }}>
                <InfoIcon sx={{ color: '#000', fontSize: 35, flex: 'none' }} />
                <Box>
                    <Typography variant="body1" sx={{ fontWeight: 700 }}>
                        {title}
                    </Typography>
                    <Typography variant="body1">
                        {text}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    )
}
